import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { Admin, AdminListParams } from '~/features/admin/types/admin.type';

/**
 * 관리자 목록 조회
 * @description 등록된 관리자 목록을 조회합니다
 * @endpoint GET /admin/admins
 * @param params - 조회 파라미터
 * @returns 관리자 목록 및 페이지네이션 정보
 */
export function getAdminListApi(params?: AdminListParams) {
  return axiosInstance.get<PaginatedApiResponse<Admin>>('/admin/admins', { params });
}
